import WishlistContent from "./wishlist-content";

export default WishlistContent;